<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              placeholder="冷藏箱编号/调度订单编号搜索..."
            />
            <b-input-group-append>
              <b-button-group slot="reference">
                <b-button
                  variant="link"
                  size="sm"
                  class="search-dropdown-button"
                  squared
                  @click="openAdvqueryDialog"
                >
                  高级搜索
                </b-button>
                <b-button variant="primary" size="sm" @click="query">
                  <i class="fa fa-search" />
                </b-button>
              </b-button-group>
            </b-input-group-append>
            <b-button-group size="sm">
              <b-button
                class="ml-2"
                variant="outline-success"
                @click="$emit('openEditFormDialog', { type: 'add' })"
                v-allow="'actAdd'"
              >
                <b-icon-plus></b-icon-plus>
                新增
              </b-button>
              <b-button
                v-allow="'actPrint'"
                variant="outline-success"
                class="ml-2"
                @click="batchDetailPrint"
              >
                <i class="el-icon-printer"></i>
                批量打印
              </b-button>
              <b-button
                class="ml-2"
                v-allow="'actImport'"
                variant="outline-primary"
                @click="openImportPage"
              >
                <b-icon-cursor></b-icon-cursor>
                导入
              </b-button>
            </b-button-group>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="98px"
        size="medium"
        label-position="left"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="冷藏箱编号">
              <el-input
                v-model.trim="form.coolerNo"
                placeholder="请输入冷藏箱编号"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="调度订单编号">
              <el-input
                v-model.trim="form.dispatchOrderNo"
                placeholder="请输入调度订单编号"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="冷藏箱长度">
              <el-input-number
                v-model="form.coolerLength"
                placeholder="请输入冷藏箱长度"
                controls-position="right"
                :min="0"
                :max="162142895431250380000"
                :step="0.01"
                :precision="2"
                clearable
                style="width:100%"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="冷藏箱宽度">
              <el-input-number
                v-model="form.coolerWidth"
                placeholder="请输入冷藏箱宽度"
                controls-position="right"
                :min="0"
                :max="162142895431250380000"
                :step="0.01"
                :precision="2"
                clearable
                style="width:100%"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="冷藏箱高度">
              <el-input-number
                clearable
                controls-position="right"
                v-model="form.coolerHeight"
                :min="0"
                :max="162142895431250380000"
                :step="0.01"
                :precision="2"
                placeholder="请输入冷藏箱高度"
                style="width:100%"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="冷藏箱容量" prop="boxType">
              <dict-select
                v-model="form.boxType"
                placeholder="请选择冷藏箱容量"
                :selectedLabel.sync="form.boxTypeName"
                default
                :body="boxTypeParams"
                clearable
                filterable
                size="medium"
              >
              </dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="可用状态">
              <el-col :span="24">
                <el-checkbox-group v-model="form.coolerStatusList">
                  <el-checkbox label="N" name="type">无效</el-checkbox>
                  <el-checkbox label="Y" name="type">有效</el-checkbox>
                </el-checkbox-group>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          取消查询
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          重置条件
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          数据检索
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const initForm = {
  keyword: '',
  coolerStatusList: ['Y'],
}
export default {
  data() {
    return {
      boxTypeParams: { type: 'boxType' },
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  created() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    batchDetailPrint() {
      this.$emit('batchDetailPrint')
    },
    openImportPage() {
      this.$router.push({
        name: 'master-cooler-import',
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
